import "../style/frame.css";
import Coin from "./coin";
import Card from "./card";
import { CARD_IMAGES } from "./cardImages";

import ribbonImage from "../images/Ribbon.png";
import starRibbonImage from "../images/Ribbon+Stars.png";

import coin2k from "../images/2K.png";
import coin5k from "../images/5K.png";
import coin10k from "../images/10K.png";
import coin20k from "../images/20K.png";
import coin50k from "../images/50K.png";

function Frame({
  coins,
  mine,
  src,
  card1,
  card2,
  card3,
  isVisibleRibbon,
  ribbonIdx,
  ribbonText,
  arrCoins,
  onClick,
  disabledClass,
  canCardShow,
  gameCoin,
}) {
  let coinImages = [coin2k, coin5k, coin10k, coin20k, coin50k];
  let ribbons = [starRibbonImage, starRibbonImage];

  const coinsRender = arrCoins.map((obj, i) => {
    const coinIndex = gameCoin.indexOf(obj.coin);
    const coinValue = gameCoin[coinIndex];
    const coinImage = coinImages[coinIndex];

    return (
      <Coin
        key={i}
        name={coinValue}
        src={coinImage}
        left={`${obj.left}%`}
        top={`${obj.top}%`}
      />
    );
  });

  let amount = 0;
  const getRenderAmount = (amo) => {
    const decimalAmo = amo;
    amount = amount + decimalAmo;

    return decimalAmo;
  };

  return (
    <div
      className="col frame "
      style={{
        backgroundImage: `url('${src}')`,
        backgroundSize: `${isVisibleRibbon === 1 ? "43vw 100%" : "85% 100%"}`,
      }}
    >
      {/* {canCardShow == true && ( */}
      <div>
        <div className="row cards">
          <Card src={CARD_IMAGES[card1]} />
          <Card src={CARD_IMAGES[card2]} />
          <Card src={CARD_IMAGES[card3]} />
        </div>
        <p className="ribbonText">{ribbonText}</p>
        <div className="sumCoins">Total: {getRenderAmount(coins)}</div>
        <div className="coins"> {coinsRender}</div>

        <div className="mine">Mine: {getRenderAmount(mine)}</div>
        <button
          className={"frameBtn " + disabledClass}
          onClick={onClick}
        ></button>
      </div>
    </div>
  );
}

export default Frame;
